// The native date input's `min` attribute discourages an earlier date but does
// not reliably block a typed/pasted value on every platform, so the wizards and
// the edit-visit form validate the first-visit due date before submitting
// (GRO-2550).
export const FIRST_VISIT_DUE_DATE_IN_PAST_ERROR = "First visit due date cannot be in the past.";

/**
 * Both args are `yyyy-MM-dd` strings (the input value and the workplace "today"
 * from {@link useFormatWorkplaceDateInput}), which sort lexicographically, so a
 * plain string comparison is enough. A blank value is not treated as in the
 * past; the wizards enforce presence separately.
 */
export function isFirstVisitDueDateInPast(firstVisitDueDate: string, todayIso: string): boolean {
  if (firstVisitDueDate.trim() === "") {
    return false;
  }

  return firstVisitDueDate < todayIso;
}
